// extracted by mini-css-extract-plugin
export default {"gameOver":"GameOver_gameOver__RRgBG"};